import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { goToPage, reportDWH } from '../../EsimQrCodeBlockSlice';
import Support from '../../Partials/Support/Support';
import AndroidCodes from './Partials/AndroidCodes';
import IosCodes from './Partials/IosCodes';
import { gtag4 } from '../../../../../utilities/analytics/tracking';

const ActivationCodesPage = (props) => {
  const [operatingSystem, setOperatingSystem] = useState('');//android|ios
  let currentView = null;

  switch (operatingSystem) {
    case 'android': currentView = <AndroidCodes />; break;
    case 'ios': currentView = <IosCodes />; break;
  }

  useEffect(() => {
    gtag4({ event: 'EsimLine_Step1_ActivatePageCode', step: '1', action: 'ActivatePageCode' });
    props.reportDWH({ actionType: 'Activaion Page - Activation Codes', status: 'Ongoing', messageText: 'Activation Codes Page Displayed' });
  }, []);

  return (
    <div className='activation-codes-page-wrapper'>
      <div className='activation-codes-page'>

        <div className='title'>הפעלת eSIM עם קודי הפעלה</div>
        <div className='sub-title'> למספר {props.subscriberNo} </div>

        <div className='seperator'></div>

        <div className='operating-system-wrapper'>
          <div className='operating-system-title'> מהו סוג המכשיר המיועד? </div>
          <div className='select-operating-system'>
            <button className={`android-icon ${operatingSystem == 'android' ? 'selected' : ''}`} onClick={handleSelectAndroid}>אנדרואיד</button>
            <button className={`ios-icon ${operatingSystem == 'ios' ? 'selected' : ''}`} onClick={handleSelectIos}>IOS</button>
          </div>
        </div>

        {currentView}

        <div className='link-wrapper'>
          <a href='#' onClick={(e) => handleGoToVideoPage(e)}>לצפייה בסרטון הוראות הפעלה</a>
        </div>

        <div className='button-wrapper'>
          <BtnSubmit
            isBusiness={false}
            text='להפעלה באמצעות קוד QR'
            onclick={handleGoToInstructionsPage}
            formid='esim-block'
            isDisplayArrows={false}
            isDisplayWhatsAppIcon={false}
          />
        </div>

        <div className='seperator'></div>

        <Support />

      </div>
    </div>
  );

  function handleGoToVideoPage(e) {
    e.preventDefault();
    props.reportDWH({ actionType: 'Activaion Page - Activation Codes', status: 'Ongoing', messageText: 'Show instruction Movie- Clicked' });
    props.goToPage('videoPage');
  }

  function handleSelectAndroid() {
    gtag4({ event: 'EsimLine_Step1_ActivatePageAndroidButton', step: '1', action: 'ActivatePageAndroidButton' });
    props.reportDWH({ actionType: 'Activaion Page - Activation Codes', status: 'Ongoing', messageText: 'Android instruction - Clicked' });
    setOperatingSystem('android');
  }

  function handleSelectIos() {
    gtag4({ event: 'EsimLine_Step1_ActivatePageAppleButton', step: '1', action: 'ActivatePageAppleButton' });
    props.reportDWH({ actionType: 'Activaion Page - Activation Codes', status: 'Ongoing', messageText: 'IOS instruction-  Clicked' });
    setOperatingSystem('ios');
  }

  function handleGoToInstructionsPage() {
    props.goToPage('instructionsPage');
  }

};

const mapStateToProps = (state) => {
  return {
    subscriberNo: state.esimQrCodeBlock.loginDetails.subscriberNo,
  };
};

const mapDispatchToProps = {
  goToPage,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivationCodesPage);
